export default __webpack_public_path__ + "static/media/awc-white.0d8e0271.svg";